import React from "react";
import AboutInfo from "./AboutInfo";
import History from "./History";
// import Services from "./Services";
// import Counter from "./Counter";
// import Progress from "./Progress";
// import Team from "./Team";
import BoardOfDirectory from "./BoardOfDirectory";
import KeyManagement from "./KeyManagement";
import WhoToday from "./WhoToday";

const About = () => {
  return (
    <div>
      <AboutInfo />
      <History />
      <WhoToday />
      <BoardOfDirectory />
      <KeyManagement />
      {/* <Services /> */}
      {/* <Counter /> */}
      {/* <Progress /> */}
      {/* <Team /> */}
    </div>
  );
};

export default About;
